import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectTrendAnalysisComponent } from './project-trend-analysis.component';

const routes: Routes = [
  {
    path: '',
    component: ProjectTrendAnalysisComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectTrendAnalysisRoutingModule { }
